var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-panda-is-not-converted"},[_c('h3',{staticStyle:{"margin-bottom":"12px"}},[_vm._v("Opa!")]),_c('span',[_vm._v("O upload desta aula ainda está sendo processado e estará disponível em breve!")])])
}]

export { render, staticRenderFns }